import React from "react";
import { useTranslation } from "react-i18next";
import { CircularProgress, Box, Typography } from "@mui/material";

const LoadingView = ({ message }) => {
  const { t } = useTranslation();
  const text = message ?? t("dsokCustomerDetail.data.loading");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
        gap: 2,
      }}
    >
      <CircularProgress />
      {text && (
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingView;
